import { connect } from 'react-redux';
import TinySelfBot from '../views/tiny/TinySelfBot';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const TinySelfBotContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinySelfBot);

export default TinySelfBotContainer;
